import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=1fcfc4b8&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcfc4b8')) {
      api.createRecord('1fcfc4b8', component.options)
    } else {
      api.reload('1fcfc4b8', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=1fcfc4b8&", function () {
      api.rerender('1fcfc4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Wrapper.vue"
export default component.exports